<button class="button">
  {{ innerText }}
</button>
